export const currentVersion = '1.0.0'

export const migrations = {
    version: currentVersion,
    // order is important, new below!
    versionsList: ['1.0.0'],
    migrationTree: [
        // Example
        // {
        //     version: '1.0.0',
        //     downgrade: null,
        //     upgrade: data => {
        //         data.testValue = true
        //         return {
        //             version: '1.0.1',
        //             data
        //         }
        //     },
        // }, {
        //     version: '1.0.1',
        //     downgrade: data => {
        //         delete data.testValue
        //         return {
        //             version: '1.0.0',
        //             data
        //         }
        //     },
    ],
}
